import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class LCDImage extends BaseFeature {
    constructor() {
        super();
        this.name = 'LCD Image';
        this.id = 'lcd_image';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'Image',
            },
            {
                id: 'IMG',
                name: 'Image',
                settingType: SettingType.FILE,
                required: true,
                default: '',
            },
            {
                id: 'WIDTH',
                name: 'Width',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '0',
            },
            {
                id: 'HEIGHT',
                name: 'Height',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '0',
            },
        ]);
    }

    getFiles() {
        const IMG = this.getSettingValue('IMG');
        const fileArray = [];
        if (IMG !== '') {
            fileArray.push(IMG.split('\n')[0]);
        }
        return fileArray;
    }
}
